import React from 'react';
import DrColum2 from '../../components/DrColumn2';
import Footer from '../../components/Footer';
import ProductResults from './../../components/ProductResults';

const Search = ({ }) => {
  return (
    <div className="searchPage">
      <ProductResults />
      <DrColum2/>
      <Footer/>
    </div>
  );
};

export default Search;
